/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { DeleteRemoveDebtorCollectionItemMutationResponse, DeleteRemoveDebtorCollectionItemPathParams, DeleteRemoveDebtorCollectionItem401, DeleteRemoveDebtorCollectionItem403 } from "../../models/DeleteRemoveDebtorCollectionItem";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getDeleteRemoveDebtorCollectionItemUrl({ debtorCode, collectionId, productCode }: { debtorCode: DeleteRemoveDebtorCollectionItemPathParams["debtorCode"]; collectionId: DeleteRemoveDebtorCollectionItemPathParams["collectionId"]; productCode: DeleteRemoveDebtorCollectionItemPathParams["productCode"] }) {
  const res = { method: 'DELETE', url: `/api/v1/debtors/${debtorCode}/collections/${collectionId}/products/${productCode}` as const }  
  return res
}

/**
 * {@link /api/v1/debtors/:debtorCode/collections/:collectionId/products/:productCode}
 */
export async function deleteRemoveDebtorCollectionItem({ debtorCode, collectionId, productCode }: { debtorCode: DeleteRemoveDebtorCollectionItemPathParams["debtorCode"]; collectionId: DeleteRemoveDebtorCollectionItemPathParams["collectionId"]; productCode: DeleteRemoveDebtorCollectionItemPathParams["productCode"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteRemoveDebtorCollectionItemMutationResponse, ResponseErrorConfig<DeleteRemoveDebtorCollectionItem401 | DeleteRemoveDebtorCollectionItem403>, unknown>({ method : "DELETE", url : getDeleteRemoveDebtorCollectionItemUrl({ debtorCode, collectionId, productCode }).url.toString(), ... requestConfig })  
  return res.data
}